<template>
  <div class="container">
    <!-- 机器人 -->
    <!-- <div class="robot" v-show="show" @click="handleOpenRobot">
      <img src="@/assets/jiopweb/robot.png" alt="">
      <span>智能导办</span>
    </div>
    <div id="robot"></div> -->
    <!-- 主题标签 -->
    <div class="tag-box">
      <div
        class="tag-item tag-item-info"
        :class="[currentTag === '0' ? 'checkedTag' : '']"
        @click="clickTag('0')"
      >
        <span>
          全部
        </span>
      </div>

      <div
        v-for="item,index in currentTheme"
        :key="item.iid"
        class="tag-item tag-item-info"
        v-show="index+1 < showTagTotal"
        :class="[currentTag === item.iid ? 'checkedTag' : '']"
        @click="clickTag(item.iid)"
      >

        <a-tooltip>
          <template slot="title">
            {{ item.subjectName }}
          </template>
          <span class="text-ellipsis">
            {{ item.subjectName }}
          </span>
        </a-tooltip>
      </div>
    </div>

    <!-- 获取更多 -->
    <div class="get-more" v-show="currentTheme.length > 12">
      <a-button type="link" v-show="showTagTotal === 12" @click="expandTheme(true)">
        查看全部
        <a-icon type="down" />
      </a-button>

      <a-button type="link" v-show="showTagTotal > 12" @click="expandTheme()">
        收起
        <a-icon type="up" />
      </a-button>
    </div>

    <!-- 表单 -->
    <div class="item-box">
      <!-- 检索条件 -->
      <div class="search-box">
        <div class="search-option">
          <a-input-search placeholder="输入事项名称检索" class="search-input" @search="onSearch" />

          <a-select class="search-select" default-value="0" @change="handleChangeItemType($event)">
            <a-select-option value="0">
              全部类型
            </a-select-option>
            <a-select-option v-for="item in itemType" :value="item.dictionaryCode" :key="item.dictionaryCode">
              {{ item.name }}
            </a-select-option>
          </a-select>

          <a-checkbox class="search-checkbox" @change="onChangeMustOnline">
            仅显示可以在线办理的事项
          </a-checkbox>
        </div>

        <span class="item-total">共 {{ itemCount }} 件事项</span>
      </div>

      <!-- 暂无事项状态 -->
      <div style="display: flex; justify-content: center; margin: 50px; flex-direction: column; align-items: center;" v-if="serviceEventList.length===0">
        <img src="../emptyList.png" alt="" />
        <span style="color: #888; font-size: 18px;">暂无事项</span>
      </div>

      <!-- 事项列表 -->
      <table class="table" v-else>
        <thead class="table-head">
          <tr class="table-head-tr">
            <th>事项名称</th>
            <th style="text-align: right;">操作</th>
          </tr>
        </thead>

        <!-- 一级标题 -->
        <table v-for="item in serviceEventList" :key="item.itemId" class="level1-box">
          <tr class="dot-text tag-title level1-title">
            <span class="level1-title-name">{{ item.itemName }}</span>

            <button @click="handleExpand(item.itemId)" class="expand-btn ">
              <!-- <span class="current-item-total">{{ item.itemName }}</span> -->

              <span style="display: none;" :ref="item.itemId + 'down'">
                <a-icon type="down"/>
              </span>
              <span style="display: inline-block;" :ref="item.itemId + 'up'">
                <a-icon type="up"/>
              </span>
            </button>
          </tr>

          <!-- 二级标题 -->
          <!-- <tr v-if="item.childItemList&& item.childItemList.length>0" :ref="item.itemId" style="display: block;">
            <table class="level2-box">
              <tr class="level2-title tag-title" v-for="i in item.childItemList" :key="i.itemId">
                <div class="level2-head">
                  <span class="dot-text level2-title-name">
                    {{ i.itemName }}
                  </span>

                  <button class="expand-btn " @click="handleExpand(i.iid)">
                    <span class="current-item-total">{{ i.itemName }}</span>

                    <span style="display: none;" :ref="i.iid + 'down'">
                      <a-icon type="down"/>
                    </span>
                    <span style="display: inline-block;" :ref="i.iid + 'up'">
                      <a-icon type="up"/>
                    </span>
                  </button>
                </div>
                <table class="level2-item-table" v-if="i.sonItemList && i.sonItemList.length > 0" :ref="i.iid" style="display: block;">
                  <tr v-for="itemInfo in i.sonItemList" :key="itemInfo.iid" class="item-box">
                    <td class="item-name" @click="toPublic(itemInfo.iid, itemInfo.guidePcSite)">{{ itemInfo.itemName }}</td>
                    <td class="item-operate">
                      <a-button class=" work-guild" v-if="itemInfo.smartGuidance == 'on'" @click="toPublic(itemInfo.iid, itemInfo.guidePcSite, true)">智能导办</a-button>
                      <a-button class="work-guild" @click="toPublic(itemInfo.iid, itemInfo.guidePcSite)">办事指南</a-button>
                      <a-button class=" online-processing-btn" v-show="itemInfo.taskOnline === 'yes'" @click="toGuide(itemInfo.iid, itemInfo.itemName, 'item', itemInfo.taskPcSite)">在线办理</a-button>
                    </td>
                  </tr>
                </table>
              </tr>
            </table>
          </tr> -->
          <!-- 事项名称 -->
          <table :ref="'event'+item.itemId" class="level1-event" style="display: block;">

            <tr v-show="item.childItemList.length>0" v-for="event in item.childItemList" :key="event.iid" class="item-box">
              <td class="item-name" @click="toPublic(event.iid, event.guidePcSite)">{{ event.itemName }}</td>
              <td class="item-operate">
                <a-button class=" work-guild" v-if="event.smartGuidance == 'on'" @click="toPublic(event.iid, event.guidePcSite, true)">智能导办</a-button>
                <a-button class=" work-guild" @click="toPublic(event.iid, event.guidePcSite)">办事指南</a-button>
                <a-button class="online-processing-btn" v-show="event.taskOnline === 'yes'" @click="toGuide(event.iid, event.itemName, 'item', event.taskPcSite)">在线办理</a-button>
              </td>
            </tr>
          </table>

        </table>
        <!-- 分页 -->
        <div class="pagination-box">
          <span class="event-total">共有{{ paginationInfo.total }}条</span>
          <a-pagination show-quick-jumper :current="paginationInfo.current" :total="paginationInfo.total" @change="onChange" />
        </div>
      </table>

      <!-- 加载状态提示 -->
      <div v-if="loading" class="loading-spinner">
        <a-spin size="large" />
      </div>

    </div>

    <a-modal :visible="visibleTip" title="提示" @ok="handleOk" @cancel="CancelTip">
      <a-row style="padding: 8px">
        <a-col :span="2" style="margin-right: 8px">
          <a-icon type="exclamation-circle" style="color: #1890ff; font-size: 22px" />
        </a-col>
        <a-col :span="20">
          <p class="info">您当前尚未登录，是否登录？</p>
        </a-col>
      </a-row>
    </a-modal>
    <a-modal v-model="draftVisible" :footer="null" :closable="false" width="420px">
      <a-row style="padding: 8px">
        <a-col :span="2" style="margin-right: 8px">
          <a-icon type="exclamation-circle" style="color: #1890ff; font-size: 22px" />
        </a-col>
        <a-col :span="20">
          <p class="info">
            您于{{ handling.ctime | timeTransfer }}保存了该事项的草稿，要继续编辑吗？
          </p>
        </a-col>
      </a-row>
      <div style="text-align: right">
        <a-button
          key="cancel"
          type="defult"
          style="margin-right: 5px"
          @click="routingHop(itemId)"
        >
          重新填报
        </a-button>
        <a-button key="submit" type="primary" @click="refill">继续编辑</a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
// import { axios } from '@/utils/request'
import { jiopAPI } from '@/api/jiopweb/jiop'
import { jiopWebAPI } from '@/api/jiopweb/jiopweb'
import { sm2 } from 'sm-crypto'
import { timeTransfer } from '@/utils/timeUtil'

export default {
  name: 'DepartmentalServices',
  props: {
    labelType: {
      type: String,
      default: 'hot'
    },
    bannerType: {
      type: String,
      default: 'personal'
    },
    districtId: {
      type: String,
      default: ''
    }
  },
  filters: {
    timeTransfer
  },
  data () {
    return {
      prikey: '5506c31374d5d8e9d79ba5ecc7cd1a7d60df3f7ef5fbb6865ccd9ce489751ac7',
      handling: { ctime: '' },
      draftVisible: false,
      currentTag: '0',
      showTagTotal: 12,
      topServiceObj: sessionStorage.getItem('JiopSelectItem') || 'personal',
      searchInfo: {
        itemName: '',
        type: '0',
        taskOnline: false
      },
      visibleTip: false,
      matterFilterListInfo: {},
      itemType: [],
      departmentThemeList: [],
      serviceEventList: [],
      paginationInfo: {
        total: 0,
        current: 1
      },
      itemCount: 0,
      loading: false,
      itemId: ''
    }
  },
  methods: {
    // 点击标签
    clickTag (tagID) {
      console.log(tagID, 'tagID')
      this.currentTag = tagID
      this.paginationInfo.current = 1
      this.getServiceList()
    },

    // 展开全部主题
    expandTheme (isExpand) {
      if (isExpand) {
        this.showTagTotal = this.currentTheme.length
      } else {
        this.showTagTotal = 12
      }
    },

    // 仅显示可以在线办理的事项
    onChangeMustOnline (e) {
      this.searchInfo.taskOnline = e.target.checked
      this.paginationInfo.current = 1
      this.getServiceList()
    },

    // 类型选择
    handleChangeItemType (value) {
      this.searchInfo.type = value
      console.log(value)
      this.paginationInfo.current = 1
      this.getServiceList()
    },

    toggleDetails (index) {
      console.log(index)
      this.items[index].showDetails = !this.items[index].showDetails
    },

    onSearch (value) {
      console.log(value)
      this.searchInfo.itemName = value
      this.paginationInfo.current = 1
      this.getServiceList()
    },

    handleExpand (key) {
      const eventItem = 'event' + key
      // 控制二级标题列表展示
      if (this.$refs[key]) {
        console.log(this.$refs[key + 'down'][0].style)

        const isShow = this.$refs[key][0].style.display === 'block'
        console.log(this.$refs[key][0].style.display)
        if (isShow) {
          this.$refs[key][0].style.display = 'none'
          this.$refs[key + 'down'][0].style.display = 'inline-block'
          this.$refs[key + 'up'][0].style.display = 'none'
        } else {
          this.$refs[key][0].style.display = 'block'
          this.$refs[key + 'down'][0].style.display = 'none'
          this.$refs[key + 'up'][0].style.display = 'inline-block'
        }
      }
      // 控制一级标题事项展示
      if (this.$refs[eventItem]) {
        const isShow = this.$refs[eventItem][0].style.display === 'block'
        if (isShow) {
          this.$refs[key + 'down'][0].style.display = 'inline-block'
          this.$refs[key + 'up'][0].style.display = 'none'
          this.$refs[eventItem][0].style.display = 'none'
        } else {
          this.$refs[key + 'down'][0].style.display = 'none'
          this.$refs[key + 'up'][0].style.display = 'inline-block'
          this.$refs[eventItem][0].style.display = 'block'
        }
      }
    },
    onChange (pageNumber) {
      console.log('Page: ', pageNumber)
      this.paginationInfo.current = pageNumber
      console.log(this.paginationInfo.current)
      this.getServiceList()
    },

    // 获取主题
    getTheme () {
      jiopWebAPI.itemThemeList({ serviceObj: this.bannerType, districtId: this.$route.query.areaCode || sessionStorage.getItem('districtId') }).then(res => {
        if (res.success) {
          this.matterFilterListInfo = res.data
          this.matterFilterListInfo.groupList.forEach(item => {
            item.subjectName = item.sname ? item.sname : item.name
          })
          this.itemType = this.matterFilterListInfo.itemType.itemType
        }
      })
    },

    // 获取部门服务主题列表
    getDepartmentTheme () {
      jiopWebAPI.groupList({ districtId: this.$route.query.areaCode || sessionStorage.getItem('districtId') }).then(res => {
        console.log(res, 'getDepartmentTheme')
        this.departmentThemeList = res.data?.groupList ? res.data.groupList : []
        this.departmentThemeList.forEach(item => {
          item.subjectName = item.sname ? item.sname : item.name
        })
      })
    },

    // 获取主题事项列表
    getServiceList () {
      console.log(this.districtId, 'this.districtId')
      this.loading = true
      const param = {
        itemName: this.searchInfo.itemName,
        districtId: this.$route.query.areaCode,
        itemTypeIds: this.searchInfo.type === '0' ? '' : this.searchInfo.type,
        taskServiceObj: this.bannerType,
        pageNo: this.paginationInfo.current,
        pageSize: 10
      }
      const tagID = this.currentTag === '0' ? '' : this.currentTag
      if (this.labelType === 'theme') {
        param.themeIds = tagID
      }
      if (this.labelType === 'department') {
        param.groupId = tagID
      }
      if (this.labelType === 'group') {
        param.applicableGroupIds = tagID
      }
      if (this.searchInfo.taskOnline) {
        param.taskOnline = 'yes'
      }
      console.log(param, 'param')
      jiopWebAPI.findServiceList(param).then(res => {
        console.log('aaaa', res)
        this.loading = false
        if (res.code === '200' && res.data.matterList?.length > 0) {
          console.log(res, '获取主题事项列表~~~~~~~~~~')
          this.serviceEventList = res.data.matterList
          this.paginationInfo.total = res.data.totalCount
          this.itemCount = res.data.outParams.itemCount
          console.log(this.serviceEventList, 'serviceEventList')
        } else {
          this.serviceEventList = []
          this.paginationInfo.total = 0
          this.itemCount = 0
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getListSize (list) {
      if (list && list.sonItemList) {
        return list.sonItemList.length
      }
      return '0'
    },

    // 前往办事指南
    toGuide (iid, name, type, taskPcSite) {
      // if (process.env.NODE_ENV === 'development') {
      //   sessionStorage.setItem(
      //     'JiopUserInfo',
      //     JSON.stringify({
      //       isLogin: true,
      //       encodeUser:
      //         '04e4d3a8e3880e5355782ba775ae7b5275437cfafbe3951d6d5668c78b7188a0f17513aa242024a2626f90ea635444c8cf2b3e8e60ce82a463d2b7a23d6f745de627cb854e617b9965b3b742980901df90449ba59dbdb46fff137a395aeb650fdc89e55c85ce7b0bbe18016bd5921db0a06444713c6de726351e52e9d1e81d84aae5258cbc30a3c40453b3d323facbc1fcfc4586390724371064d78080f5f2b677d26318185761ac05418719e429d3bace6f3891e8f1bf50dcb8761d6691f901d5a81c87ede7377c030875ccb4c009b2371a2bab6a3160b2c6ea9b02402711964956974590caf43f83b8a7fdb63e70b7e9f09fea7a0f14d61def84d1c6f80d75cf5897344ab23b036e7a0ac4787d3064c1eb6f3d74fe9b87ca6b56c89b6908846d9e52ead5d2666cf8a4b705b051817640f30b8e713cd33fe5f7eb6b0f4a25b0bee0004bd7dc8f3f80cf17c254b7d06c5b1529b790372a840a935af3377e127a48ffca',
      //       desensitizeUser:
      //         '{"uid":"0220f55db69b4f249e8b69b80afb9d95","userType":1,"name":"*春翔","mobile":"152******89","certType":"居民身份证","certNo":"3****************1","corporationName":null,"creditCode":null,"corUserName":null,"corUserCertType":null,"corUserCertNo":null}',
      //       accessToken:
      //         'd941894e013b4435ba0a1e527323a7e9'
      //       // 'access-token': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2OTQ0MTg4MTMsImlhdCI6MTY5NDQwMDgxMywidXNlcm5hbWUiOiIwMjIwZjU1ZGI2OWI0ZjI0OWU4YjY5YjgwYWZiOWQ5NSJ9.3tMTDJih83tyBFTKq4xn289VaLHFg8O-5JefwknEJZw'
      //     })
      //   )
      //   document.cookie =
      //     'accessToken=d941894e013b4435ba0a1e527323a7e9'
      //   sessionStorage.setItem('JiopSelectItem', 'personal')
      //   // axios.defaults.headers['access-token'] = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2OTQ0MTg4MTMsImlhdCI6MTY5NDQwMDgxMywidXNlcm5hbWUiOiIwMjIwZjU1ZGI2OWI0ZjI0OWU4YjY5YjgwYWZiOWQ5NSJ9.3tMTDJih83tyBFTKq4xn289VaLHFg8O-5JefwknEJZw'
      //   axios.defaults.headers['accessToken'] =
      //     'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2OTQ0MTg4MTMsImlhdCI6MTY5NDQwMDgxMywidXNlcm5hbWUiOiIwMjIwZjU1ZGI2OWI0ZjI0OWU4YjY5YjgwYWZiOWQ5NSJ9.3tMTDJih83tyBFTKq4xn289VaLHFg8O-5JefwknEJZw;path=/'
      // }
      console.log(sessionStorage.getItem('JiopUserInfo'), 'sessionStorage.getItem(JiopUserInfo)')
      this.itemId = iid
      if (this.identityCheck(name)) {
        // 清空智能填报缓存
        sessionStorage.removeItem(this.itemId + 'SmartFill')
        // 跳转到办事流程
        if (taskPcSite) {
          window.open(taskPcSite, '_blank')
        } else {
          this.getItemBeanSimple(iid, type)
        }
      }
    },

    // 去简单办事指南
    toPublic (value, guidePcSite, showRobot) {
      const url = this.$router.resolve({
        path: '/guideSimple',
        query: {
          itemId: value,
          areaCode: this.$route.query.areaCode,
          bannerType: this.$route.query.bannerType,
          showRobot
        }
      })
      if (guidePcSite) {
        window.open(guidePcSite, '_blank')
      } else {
        window.open(url.href, '_blank')
      }
      // window.open(url.href, '_blank')
    },

    // 清除session
    cleanSession () {
      sessionStorage.removeItem(this.itemId + '_listOfSituations')
      sessionStorage.removeItem(this.itemId + '_model')
      sessionStorage.removeItem(this.itemId + '_infoStr')
      sessionStorage.removeItem(this.itemId + '_JiopwebReceive')
      sessionStorage.removeItem(this.itemId + '_JiopwebMaterial')
      // 清空智能填报缓存
      sessionStorage.removeItem(this.itemId + 'SmartFill')
    },
    // 校验是否登录，若已登录校验是个人还是法人，未登录去登录
    identityCheck (name) {
      if (sessionStorage.getItem('JiopUserInfo')) {
        const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
        if (userInfo.isLogin) {
          const userParams = JSON.parse(userInfo.desensitizeUser)
          const userType =
            this.getCookieData('userType') === 1 || parseInt(userParams.userType) === 1
              ? 'personal'
              : 'legalperson'
          const seletType =
            this.$route.query.bannerType === 'oneThing'
              ? this.personOneThing
                ? 'personal'
                : 'legalperson'
              : this.$route.query.bannerType
          if (seletType !== userType) {
            const type =
              this.$route.query.bannerType === 'personal'
                ? '个人'
                : this.$route.query.bannerType === 'legalperson'
                  ? '法人'
                  : this.personOneThing
                    ? '个人'
                    : '法人'
            this.$info({
              title: `该事项仅限${type}账户办理`,
              content: (
                <div>
                  您不是{name}的服务对象
                  <br />
                  请登录{type}账户再来吧
                </div>
              ),
              onCancel () {}
            })
            return false
          } else {
            return true
          }
        } else {
          // 是否登录提示框（未登录）
          this.visibleTip = true
          return false
        }
      } else {
        // 是否登录提示框（未登录）
        this.visibleTip = true
        return false
      }
    },
    findOptionList (paramter, type) {
      jiopAPI.findOption(Object.assign({ type: paramter })).then(res => {
        if (res.success) {
          if (res.data.data.serviceObject) {
            const objNameList = []
            const serviceObjList = this.itemInfoBean.taskServiceObj
              ? this.itemInfoBean.taskServiceObj.split(',')
              : []
            res.data.data.serviceObject.forEach(val => {
              serviceObjList.forEach(v => {
                if (v === val.dictionaryCode) {
                  objNameList.push(val.name)
                }
              })
            })
            this.serviceObjectName = objNameList.join('、')
            this.setMatterSession(this.itemInfoBean, this.reportConfigByIid, this.itemId, type)
            // 判断是否有草稿
            this.getDraft(this.itemId)
          }
        }
      })
    },
    getDraft (iid) {
      this.cleanSession()
      const that = this
      const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))

      let userParams
      if (JSON.parse(userInfo.desensitizeUser)) {
        userParams = JSON.parse(userInfo.desensitizeUser)
      }
      let userId
      if (userParams && userParams.uid) {
        userId = userParams.uid
      }
      jiopWebAPI.queryDraft({ userId: userId, matterId: iid }).then(res => {
        if (res.success) {
          if (res.data.draft.handling && res.data.draft.metaStyle) {
            const jsonHandling = sm2.doDecrypt(res.data.draft.handling.substring(2), that.prikey, 1)
            const jsonMetaStyle = sm2.doDecrypt(
              res.data.draft.metaStyle.substring(2),
              that.prikey,
              1
            )
            console.log(jsonHandling, 'jsonHandling')
            if (jsonHandling && jsonMetaStyle) {
              that.handling = JSON.parse(jsonHandling)
              that.metaStyle = JSON.parse(jsonMetaStyle)
              // that.materialList = res.data.draft.itemMaterialList || []
              // that.draftVisible = true
            }
            // that.handling = JSON.parse(jsonHandling)
            // that.metaStyle = JSON.parse(jsonMetaStyle)
            that.draftVisible = true
            // that.routingHop(iid)
            that.materialList = res.data.draft.itemMaterialList || []
          } else {
            that.routingHop(iid)
          }
        }
      })
    },
    setSessionData () {
      if (this.handling.situationSelect) {
        // 存入情形
        sessionStorage.setItem(this.itemId + '_listOfSituations', this.handling.situationSelect)
      }
      if (this.handling.model && this.metaStyle.formData) {
        // 存入表单
        sessionStorage.setItem(this.itemId + '_model', this.handling.model)
        sessionStorage.setItem(this.itemId + '_infoStr', this.metaStyle.formData)
      }
      // 存入上传材料(当上传材料发生改变时，后台清除已上传的材料，不需要前端比对)
      if (this.metaStyle && this.metaStyle.uploadMaterial) {
        sessionStorage.setItem(this.itemId + '_JiopwebMaterial', this.metaStyle.uploadMaterial)
      }
      if (parseInt(this.handling.receiveType) === 0 || parseInt(this.handling.receiveType) === 1) {
        // 存入取件方式
        const params = { receiveType: this.handling.receiveType }
        if (parseInt(this.handling.receiveType) === 1) {
          params.receiveUserName = this.handling.receiveUserName
          params.receivePhone = this.handling.receivePhone
          params.receiveDetailArea = this.handling.receiveDetailArea
          params.receiveArea = this.handling.receiveArea
        }
        sessionStorage.setItem(this.itemId + '_JiopwebReceive', JSON.stringify(params))
      }
    },
    // 继续编辑
    refill () {
      const that = this
      this.setSessionData()
      jiopWebAPI.findReportConfigByIid({ itemid: this.itemId }).then(res => {
        let total = 0
        const fillingInstruction = res.data.data.fillingInstruction
        const situation = res.data.data.situation
        const formConfig = res.data.data.formConfig
        const uploadMaterial = res.data.data.uploadMaterial
        const pickupMethod = res.data.data.pickupMethod
        const inforMationConfirmed = res.data.data.inforMationConfirmed
        const intelligentApproval = res.data.data.intelligentApproval ? res.data.data.intelligentApproval : 'off'
        const acceptFlowId = res.data.data.acceptFlowId
        const wholeIntelligentApproval = res.data.data.wholeIntelligentApproval ? res.data.data.wholeIntelligentApproval : 'off'
        const stepList = []
        if (fillingInstruction === 'on') {
          total++
          stepList.push({ name: 'fillInstruction', isOpen: false })
        }
        if (situation === 'on') {
          total++
          stepList.push({ name: 'selectSitution', isOpen: false })
        }
        if (formConfig === 'on') {
          total++
          stepList.push({ name: 'matterForm', isOpen: false })
        }
        if (uploadMaterial === 'on') {
          total++
          stepList.push({ name: 'uploadMaterial', isOpen: false })
        }
        if (pickupMethod === 'on') {
          total++
          stepList.push({ name: 'receiveInfo', isOpen: false })
        }
        if (inforMationConfirmed === 'on') {
          total++
          stepList.push({ name: 'confirmInfo', isOpen: false })
        }
        const stepNo = that.handling.steps
        const router = '/' + stepList[stepNo].name
        const handleType = this.handleType === 'item' ? 'item' : 'onething'
        that.$router.push({
          path: router,
          query: {
            itemId: that.itemId,
            stepNo: stepNo,
            total: total,
            flagTag: '0',
            flowId: res.data.data.flowId,
            handleType: handleType,
            materialList: JSON.stringify(that.materialList),
            intelligentApproval: intelligentApproval,
            acceptFlowId: acceptFlowId,
            wholeIntelligentApproval: wholeIntelligentApproval
          }
        })
      })
    },
    // 获取matter数据并存入缓存
    getItemBeanSimple (iid, type) {
      this.handleType = type
      if (type === 'onething') {
        jiopAPI.oneThingGuide({ iid: iid }).then(res => {
          if (res.success) {
            if (res.data.oneThings && res.data.reportConfigByIid) {
              this.itemInfoBean = res.data.oneThings || {}
              this.reportConfigByIid = res.data.reportConfigByIid
              this.findOptionList(
                'materialNecessity,serviceObject,consultationMethod,complaintMethod,materialType,materialForm,sourceChannels',
                type
              )
            }
          }
        })
      } else {
        jiopAPI.findItemBeanSimple({ itemId: iid }).then(res => {
          if (res.success) {
            if (res.data.itemInfoBean && res.data.reportConfigByIid) {
              this.itemInfoBean = res.data.itemInfoBean || {}
              this.reportConfigByIid = res.data.reportConfigByIid
              this.findOptionList(
                'materialNecessity,serviceObject,consultationMethod,complaintMethod,materialType,materialForm,sourceChannels',
                type
              )
            }
          }
        })
      }
    },
    setMatterSession (itemInfoBean, reportConfigByIid, itemId, type) {
      console.log(itemInfoBean)
      const obj = {}
      obj.tag = this.serviceObjectName
      obj.groupName = itemInfoBean.deptName
      if (type === 'onething') {
        obj.applyName = itemInfoBean.oneThingName
        obj.matterName = itemInfoBean.oneThingName
      } else {
        obj.applyName = itemInfoBean.itemName
        obj.matterName = itemInfoBean.itemName
      }
      obj.applySource = 'PC'
      obj.matterId = itemInfoBean.iid
      obj.taskCode = itemInfoBean.taskCode
      obj.code = '11'
      obj.flowId = reportConfigByIid.flowId
      obj.metaId = reportConfigByIid.metaId
      const matter = JSON.stringify(obj)
      sessionStorage.setItem(itemId + '_matter', matter)
    },
    getCookieData (cookieName) {
      try {
        var name = cookieName + '='
        var cookieMsg = document.cookie.replace(/%/g, '%25')
        var decodedCookie = decodeURIComponent(cookieMsg)
        var cookieArray = decodedCookie.split(';')
        for (var i = 0; i < cookieArray.length; i++) {
          var cookie = cookieArray[i]
          while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1)
          }
          if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length)
          }
        }
        return ''
      } catch (err) {
        console.log(err, 'cookieErr')
      }
    },

    // 智能导办
    handleOpenRobot (title, itemId) {
      console.log(title, itemId, 'handleOpenRobot')
      window.openDialog('robot', title, itemId, this.$route.query.areaCode, 'jiop')
    },

    handleOk () {
      this.visibleTip = false
      this.toLoginPage()
    },
    toLoginPage () {
      const params = this.$route.query || {}
      params.jiopWorkUrl = 'jiopweb/' + this.$route.name
      jiopWebAPI.getLoginUrl({ params: JSON.stringify(params) }).then(res => {
        if (res.success) {
          if (res.data.url) {
            window.location.href = res.data.url
          }
        }
      })
    },

    CancelTip () {
      this.visibleTip = false
    },

    // 获取cookie
    getCookie (name) {
      const cookieStr = document.cookie
      const cookies = cookieStr.split(';')
      console.log('cookieStr', cookieStr)
      for (let i = 0; i < cookies.length; i++) {
        const cookiePair = cookies[i].split('=')
        const cookieName = cookiePair[0].trim()
        if (cookieName === name) {
          return cookiePair[1]
        }
      }
      return null
    },
    getSteps (iid) {
      jiopWebAPI.findReportConfigByIid({ itemid: iid }).then(res => {
        const fillingInstruction = res.data.data.fillingInstruction
        const situation = res.data.data.situation
        const formConfig = res.data.data.formConfig
        const uploadMaterial = res.data.data.uploadMaterial
        const pickupMethod = res.data.data.pickupMethod
        const inforMationConfirmed = res.data.data.inforMationConfirmed
        sessionStorage.setItem(
          iid + '_fill',
          JSON.stringify({
            userAgreeMentName: res.data.data.userAgreeMentName,
            userAgreementContent: res.data.data.userAgreementContent
          })
        )
        let total = 0
        if (fillingInstruction === 'on') {
          total++
        }
        if (situation === 'on') {
          total++
        }
        if (formConfig === 'on') {
          total++
        }
        if (uploadMaterial === 'on') {
          total++
        }
        if (pickupMethod === 'on') {
          total++
        }
        if (inforMationConfirmed === 'on') {
          total++
        }
        const handleType = this.handleType === 'item' ? 'item' : 'onething'
        if (fillingInstruction === 'on') {
          const url = this.$router.resolve({
            path: '/fillInstruction',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType,
              bannerType: this.$route.query.bannerType
            }
          })
          window.open(url.href, '_blank')
        } else if (situation === 'on') {
          const url = this.$router.resolve({
            path: '/selectSitution',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType,
              bannerType: this.$route.query.bannerType
            }
          })
          window.open(url.href, '_blank')
        } else if (formConfig === 'on') {
          const url = this.$router.resolve({
            path: '/matterForm',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType,
              bannerType: this.$route.query.bannerType
            }
          })
          window.open(url.href, '_blank')
        } else if (uploadMaterial === 'on') {
          const url = this.$router.resolve({
            path: '/uploadMaterial',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType,
              bannerType: this.$route.query.bannerType
            }
          })
          window.open(url.href, '_blank')
        } else if (pickupMethod === 'on') {
          const url = this.$router.resolve({
            path: '/receiveInfo',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType,
              bannerType: this.$route.query.bannerType
            }
          })
          window.open(url.href, '_blank')
        } else if (inforMationConfirmed === 'on') {
          const url = this.$router.resolve({
            path: '/confirmInfo',
            query: {
              itemId: this.itemId,
              stepNo: 0,
              total: total,
              flowId: res.data.data.flowId,
              handleType: handleType
            }
          })
          window.open(url.href, '_blank')
        }
      })
    },
    routingHop (iid) {
      this.getSteps(iid)
    }
  },

  watch: {
    currentTheme: {
      handler (newVal, oldVal) {
        console.log(newVal, this)
        this.currentTag = '0'
      }
    },
    bannerType: {
      handler (newVal, oldVal) {
        console.log(newVal, this)
        this.currentTag = '0'
      }
    },
    districtId: {
      handler (newVal, oldVal) {
        console.log(newVal, this)
        this.clickTag('0')
      }
    }
  },
  computed: {
    currentTheme () {
      let list
      switch (this.labelType) {
        case 'theme':
          list = this.matterFilterListInfo.subjectList.theme ? this.matterFilterListInfo.subjectList.theme : []
          break
        case 'group':
          list = this.matterFilterListInfo.subjectList.groups ? this.matterFilterListInfo.subjectList.groups : []
          break
        case 'department':
          list = this.matterFilterListInfo.groupList ? this.matterFilterListInfo.groupList : []
          break
        default:
          list = []
      }
      console.log(list, '=====list')
      return list
    }
  },
  created () {
    if (this.getCookie('areaCodeCookie')) {
      sessionStorage.setItem('districtId', this.getCookie('areaCodeCookie'))
      console.log(this.getCookie('areaCodeCookie'), 'areaCodeCookie')
    }
  },
  mounted () {
    this.getServiceList()
    this.getTheme()
    this.getDepartmentTheme()
  }
}
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: auto;
  position: relative;

  .tag-box {
    display: flex;
    text-align: center;
    // justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 30px;
    gap: 20.4px 20px;

    // 每行最多显示6个元素
    .tag-item {
      display: flex;
      // width: 16.666666666666668%;
      width: 183px;
      padding: 10px;
        height: 50px;
      // display: inline-flex;
      align-items: center;
      justify-content: center;
      // 设置边框阴影
      box-shadow: 0px 0px 14px 0px rgba(0,0,0,0.1);
      cursor: pointer;

      .tag-item-info {
        width: 100%;
        // margin: 0 10px 20px;
        font-size: 16px;
        color: #333333;
      }
      .text-ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

    }
    .tag-item-info:hover {
      // 鼠标移入缓慢上移
      // transition: all 0.3s;
      // transform: translateY(-5px);
      background: #4393F5;
      color: #fff;
    }

    .checkedTag {
      background: #4393F5;
      color: #fff;
    }
  }

  /* 最后一行不足6个元素的情况下，剩余的元素左对齐 */
  // .tag-box::after {
  //     content: "";
  //     flex: auto; /* 充满剩余的空间 */
  // }

  .get-more {
    text-align: center;
    margin: 15px 0 10px 0;
    font-size: 14px;
    color: #4393F5;
  }

  .item-box {
    position: relative;
    .search-box {
      padding: 20px 0;
      border-radius: 5px;
      align-items: center;
      display: flex;

      .search-option {
        .search-input{
          width: 260px;
        }
        ::v-deep .ant-input {
          height: 40px;
          border: 1px solid rgba(215,216,217,1);
        }

        ::v-deep .ant-select-selection__rendered {
          line-height: 40px;
        }

        ::v-deep .ant-select-selection--single {
          height: 40px;

        }

        .search-select {
          margin-left: 20px;
          width: 120px
        }

        .search-checkbox {
          margin-left: 20px;
          font-size: 14px;
          color: #333333;
        }
      }
    }

    .item-total {
      height: 100%;
      align-items: center;
      justify-content: flex-end;
      // 靠右显示
      margin-left: auto;
      font-size: 12px;
      color: #666666;
    }

    .table {
      width: 100%;
      // border-collapse: collapse;
      font-size: 16px;
      display: block;

      .table-head {
        background-color: #f2f2f2;
        display: table-caption;
        padding: 10px 20px;
        height: 40px;
        width: 1200px;

        .table-head-tr {
          display: flex;
          justify-content: space-between;
          // text-align: left;
          // border-bottom: 1px solid #e8e8e8;

          th {
            font-size: 14px;
            color: #666666;
            font-weight: 400;
          }
        }
      }

      .tag-title {
        font-size: 16px;
        color: #333333;
      }

      .dot-text::before {
          content: "•"; /* 插入一个点作为内容 */
          margin-right: 0.5em; /* 可选：为了与文本有间距，添加右边距 */
          margin-bottom: 0;
      }

      .level1-box {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        padding: 5px 0;
        border-bottom: 1px solid rgba(215,216,217,0.5);
        // padding-bottom: 14px;

        tr {
          display: table-row;
          width: 100%;
        }

        .level1-event {
          display: block;
          width: 100%;
        }

        .level1-title {
          width: 100%;
          padding: 10px 0;
          display: flex;
          align-items: center;

          .level1-title-name {
            display: inline-block;
            height: 100%;
            max-width: 50%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .expand-btn {
          border: none;
          padding: 4px 10px;
          cursor: pointer;
          margin-left: 15px;
          min-width: 55px;
          height: 28px;
          font-size: 14px;
          color: #2B2F32;
          // display: flex;
          justify-content: space-between;

          .current-item-total {
            margin-right: 15px;
          }
        }

        .item-box {
          width: 1200px;
          // width: 100%;
          height: 50px;
          // margin-top: 20px;
          color: #1890ff;
          display: flex;
          justify-content: space-between;
          align-items: center;

          td {
            width: 50%;
          }

          &:hover {
            background: #F1F2F3;
          }

          .item-name {
            // display: flex;
            white-space: nowrap;
            overflow: hidden;
            align-items: center;
            text-indent: 3rem;
            flex-wrap: nowrap;
            text-overflow: ellipsis;
            cursor: pointer;
          }

          .item-operate {
            display: flex;
            justify-content: flex-end;
            padding-right: 20px;

            // 第二个按钮距离第一个按钮10px
            button:nth-child(2) {
              margin-left: 20px;
            }
            button:nth-child(3) {
              margin-left: 20px;
            }

            button {
              border: none;
              border-radius: 0;
              font-size: 14px;
            }

            .online-processing-btn {
              background: #4393F5;
              color: #FFFFFF;
            }

            .work-guild {
              background: #EBF2FC;
              color: #4393F5;
            }
          }
        }

        .level2-box {
          width: 100%;
          display: flex;
          flex-wrap: wrap;

          .level2-title {
            width: 100%;
            text-indent: 1rem;

            .level2-item-table {
              width: 100%;

              .item-name {
                text-indent: 3rem;
              }

              &:first-child {
                margin-top: 100px;
              }
            }

            .level2-head {
              height: 50px;
              display: flex;
              align-items: center;

              .level2-title-name {
                display: inline-block;
                max-width: 50%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: start;
              }
            }
          }
        }
      }

      .tr {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        border-bottom: 1px solid #e8e8e8;
      }
    }

    .pagination-box {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px 0;

      .event-total {
        margin-right: 12px;
        font-size: 14px;
        color: #666666;
      }
    }

  }
}

::v-deep .ant-pagination-item-active {
  background: #4393F5;
  border-color: #4393F5;
  color: #fff;

  a {
    color: #fff;
  }
}

.loading-spinner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7); /* 半透明白色背景 */
  z-index: 9999; /* 确保在最顶层显示 */
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
